// Shared FAQ source of truth.
// Keep questions identical to the JSON-LD FAQPage in /app/frontend/public/index.html
// so what bots see matches what users see.

export const FAQS = [
  {
    q: "What services does Indoor Greens offer?",
    a: "Indoor Greens provides complete landscaping and plant solutions for residential and commercial spaces. Our services include:",
    list: [
      "Landscape Design & Execution",
      "Indoor Plant Styling",
      "Outdoor Landscaping",
      "Vertical Gardens (Green Walls)",
      "Terrace Gardens",
      "Balcony Gardens",
      "Plant Rental for Offices & Events",
      "Indoor & Outdoor Plant Maintenance",
      "Corporate Green Solutions",
      "Premium Planters & Pots",
      "Irrigation Systems",
      "Garden Renovation & Makeovers",
      "Nursery Plants & Gardening Supplies",
      "Custom Green Solutions for Homes, Offices, Hotels, Restaurants, Hospitals & Retail Spaces",
    ],
    footer:
      "Whether you're transforming a small balcony or developing a large commercial landscape, we provide end-to-end design, installation and maintenance.",
  },
  {
    q: "Which locations do you serve?",
    a: "We primarily serve Mumbai, Navi Mumbai, Thane and surrounding areas. For large commercial and landscaping projects we also undertake work across Maharashtra and other parts of India.",
  },
  {
    q: "Do you provide a free site visit?",
    a: "Yes. We offer a consultation and site visit to understand your space, lighting, requirements and budget before preparing a customised proposal.",
  },
  {
    q: "Do you design gardens for small balconies and terraces?",
    a: "Absolutely. Whether you have a compact apartment balcony or a spacious terrace, we create beautiful, functional green spaces that maximise every square foot.",
  },
  {
    q: "What is a vertical garden?",
    a: "A vertical garden is a living green wall where plants are grown on specially designed structures. It enhances aesthetics, improves air quality, reduces heat and is ideal for homes, offices, balconies and commercial buildings with limited floor space.",
  },
  {
    q: "Can you recommend plants based on my space?",
    a: "Yes. Our experts assess natural light, ventilation, air conditioning and maintenance preferences before recommending the most suitable plants for your space.",
  },
  {
    q: "Do you offer plant maintenance services?",
    a: "Yes. We provide professional maintenance including watering, pruning, fertilising, pest control, plant replacement (where applicable) and general plant care to keep your greenery healthy all year round.",
  },
  {
    q: "Do you provide Annual Maintenance Contracts (AMC)?",
    a: "Yes. We offer flexible Annual Maintenance Contracts for homes, offices, hotels, restaurants, hospitals and commercial properties.",
  },
  {
    q: "Do you rent plants for offices and events?",
    a: "Yes. We provide indoor and outdoor plant rental services for offices, exhibitions, weddings, corporate events, retail stores, hotels, restaurants and special occasions.",
  },
  {
    q: "How long does a landscaping project take?",
    a: "It depends on the size and complexity of the project. Small installations can often be completed within a day, while larger landscaping projects may take several days or weeks. We share a clear project schedule before starting work.",
  },
  {
    q: "Do you supply planters and pots?",
    a: "Yes. We offer a wide selection of premium planters in ceramic, FRP, metal, concrete, fibreglass and other finishes to complement every interior and landscape design.",
  },
  {
    q: "Which indoor plants are best for offices?",
    a: "Popular office plants include Snake Plant, ZZ Plant, Peace Lily, Areca Palm, Rubber Plant, Aglaonema, Philodendron, Dracaena and Pothos. We recommend plants based on your office's lighting and maintenance requirements.",
  },
  {
    q: "Can you create low-maintenance gardens?",
    a: "Yes. We specialise in designing gardens using hardy, low-maintenance plants along with efficient irrigation systems — ideal for busy homeowners and commercial properties.",
  },
  {
    q: "Do you work on residential and commercial projects?",
    a: "Yes. We undertake projects for homes, apartments, villas, offices, corporate campuses, hotels, restaurants & cafés, hospitals, educational institutions, retail stores, shopping malls and industrial facilities. No project is too small or too large.",
  },
  {
    q: "How much does landscaping cost?",
    a: "The cost depends on project size, plant selection, materials, irrigation requirements and design complexity. We provide customised quotations based on your specific requirements and budget.",
  },
  {
    q: "Why should I choose Indoor Greens?",
    a: "Indoor Greens combines creativity, horticultural expertise and quality workmanship to create beautiful, sustainable green spaces. From design and execution to ongoing maintenance, we offer complete end-to-end solutions with a strong focus on quality, reliability and customer satisfaction.",
  },
  {
    q: "How do I get started?",
    a: "Contact us via phone, WhatsApp or by filling out the enquiry form on our website. Our team will schedule a consultation, discuss your requirements and recommend the best green solutions for your space.",
  },
];
